import { useEffect, useState } from "react";
import { api } from "./api";

// Lecture publique des emplacements éditoriaux (médiathèque ↔ pages).
// Cache module-level : une seule requête par chargement, réutilisée par toutes les sections.
let cache = null;

export function usePageMedia() {
  const [media, setMedia] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/page-media").then((r) => { cache = r.data || {}; setMedia(cache); }).catch(() => setMedia({}));
  }, []);
  return media;
}
